import useComplianceCargoValidationSchema from "../shared/validation/useComplianceCargoValidationSchema"
import useCompliancePermitTypeValidationSchema from "../shared/validation/useCompliancePermitTypeValidationSchema"
import useComplianceLicenceValidationSchema from "../shared/validation/useComplianceLicenceValidationSchema.js.js"
import useComplianceTransportValidationInSchema from "../shared/validation/useComplianceTransportValidationInSchema"
import useComplianceContainerValidationSchema from "../shared/validation/usComplianceContainerValidationSchema"
import useComplianceInvoiceValidationSchema from "../shared/validation/useComplianceInvoiceValidationSchema"

function useCreatePermitMakeValidationInPaySchema() {
    return useCompliancePermitTypeValidationSchema()
        .concat(useComplianceCargoValidationSchema())
        .concat(useComplianceContainerValidationSchema())
        .concat(useComplianceTransportValidationInSchema())
        .concat(useComplianceLicenceValidationSchema())
        .concat(useComplianceInvoiceValidationSchema())
}
export default useCreatePermitMakeValidationInPaySchema